import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';

const Footer = () => {
  const footerLinks = {
    Company: [
      { name: 'About Us', link: '/about' },
      { name: 'Contact', link: '/contact' }
    ],
    Legal: [
      { name: 'Privacy Policy', link: '/privacy' },
      { name: 'Refund Policy', link: '/refund' },
      { name: 'Terms & Conditions', link: '/terms' }
    ]
  };

  return (
    <footer className="bg-gradient-to-b from-green-50 to-white py-8 md:py-12">
      <div className="w-full max-w-[85%] mx-auto px-4 md:px-6">
        {/* Footer Card */}
        <motion.div
          className="bg-white/90 backdrop-blur-xl rounded-3xl p-8 md:p-12 shadow-xl border border-gray-100/50"
          style={{
            background: 'linear-gradient(145deg, rgba(255,255,255,0.95), rgba(255,255,255,0.85))',
            boxShadow: '0 20px 60px -10px rgba(0,0,0,0.08), 0 8px 20px -5px rgba(76,175,80,0.08)'
          }}
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          {/* Main Footer Content */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8 lg:gap-12 mb-8 lg:mb-10">
            {/* Brand Section */}
            <div className="text-center md:text-left">
              {/* Logo */}
              <div className="flex items-center justify-center md:justify-start space-x-3 mb-4 lg:mb-6">
                <img src="/logo.png" alt="SMR Online Logo" className="w-12 h-12 md:w-14 md:h-14 rounded-xl shadow-md" />
                <h3 className="text-2xl md:text-3xl font-bold text-gradient">SMR Online</h3>
              </div>

              <p className="text-gray-600 mb-4 lg:mb-6 text-sm md:text-base max-w-md mx-auto md:mx-0 leading-relaxed">
                The ultimate Matka app where you can get fastest results, best market rates, and secure withdrawals.
              </p>

              {/* Contact Info */}
              <div className="inline-flex items-center space-x-3 bg-green-50 border border-green-100 rounded-full px-4 py-2">
                <Mail className="w-4 h-4 text-primary flex-shrink-0" />
                <span className="text-gray-700 text-sm">support@smronline.org</span>
              </div>
            </div>

            {/* Links Section */}
            <div className="mt-8 md:mt-0">
              <h4 className="text-gray-900 font-semibold mb-4 lg:mb-6 text-center md:text-left text-lg">Quick Links</h4>
              <div className="grid grid-cols-2 gap-6 lg:gap-8">
                {Object.entries(footerLinks).map(([category, links]) => (
                  <div key={category} className="text-center md:text-left">
                    <h5 className="text-primary font-medium mb-3 text-sm md:text-base">{category}</h5>
                    <ul className="space-y-2">
                      {links.map((link, linkIndex) => (
                        <li key={linkIndex}>
                          <Link
                            to={link.link}
                            className="text-gray-500 hover:text-primary transition-colors duration-300 text-sm"
                          >
                            {link.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Divider */}
          <div className="h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent mb-6"></div>

          {/* Copyright */}
          <div className="text-center">
            <p className="text-gray-500 text-sm">
              © 2026 SMR Online. All rights reserved.
            </p>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
